import React from 'react'
import {
  Box,
  IcoMoon,
  Text,
  BarcodePinkIcon,
  FormPinkIcon,
  TruckPinkIcon,
} from "@usap/uicomponents"

export default function OwnShippingLabel({ addressDisplay, isDesktop }) {
  return (
    <>
      <Box pad="medium">
        <Text size={isDesktop ? 'small' : 'large'} color="dark-2" weight="bold">
          Here’s how to get your item(s) back to us:
        </Text>
      </Box>
      <Box align="center">
        <Box direction="row" pad="small" align="center">
          <Box width="xxsmall" margin={{ right: '16px' }}>
            <IcoMoon icon={FormPinkIcon} />
          </Box>
          <Box width={isDesktop ? 'medium' : 'small'}>
            <Text size="xsmall">
              1. Write your RMA ID on the Shipping Label you
              purchase from your respective carrier.
            </Text>
          </Box>
        </Box>

        <Box direction="row" pad="small" align="center">
          <Box width="xxsmall" margin={{ right: '16px' }}>
            <IcoMoon icon={BarcodePinkIcon} />
          </Box>
          <Box width={isDesktop ? 'medium' : 'small'}>
            <Text size="xsmall">
              2. You can use any carrier of your choice
              to ship back the return. However, we highly recommend
              that you obtain a Tracking Number. The Tracking Number
              would serve as your proof of delivery if the package is misplaced.
            </Text>
          </Box>
        </Box>

        <Box direction="row" pad="small" align="center">
          <Box width="xxsmall" margin={{ right: '16px' }}>
            <IcoMoon icon={TruckPinkIcon} />
          </Box>
          <Box width={isDesktop ? 'medium' : 'small'}>
            <Text size="xsmall">
              3. Please send your return to this address: <br />
              <strong>{ addressDisplay }</strong>
            </Text>
          </Box>
        </Box>
      </Box>
    </>
  )
}
